import React, { createContext, useContext } from 'react'

import { usePairCatalog } from './hooks/usePairCatalog'
import { useTokenCatalog } from './hooks/useTokenCatalog'
import { useWalletPermissions } from './hooks/useWalletPermissions'
import { useMarketApiStatus, type MarketApiAvailability } from './useMarketApiStatus'

const MarketApiContext = createContext<MarketApiAvailability | null>(null)

function MarketCatalogSync() {
  // Product-config catalogs + static permissions (identity / policy).
  useTokenCatalog()
  usePairCatalog()
  useWalletPermissions()
  return null
}

/**
 * Syncs product-config catalogs/policy for operativa (swap/LP).
 * Vitrina data plane lives in NutrimaticMarketProvider — not here.
 */
export function MarketApiProvider({ children }: { children: React.ReactNode }) {
  const status = useMarketApiStatus()
  return (
    <MarketApiContext.Provider value={status}>
      <MarketCatalogSync />
      {children}
    </MarketApiContext.Provider>
  )
}

export function useMarketApiContext(): MarketApiAvailability {
  const ctx = useContext(MarketApiContext)
  if (!ctx) {
    return {
      configured: false,
      isAvailable: false,
      isDegraded: false,
      chainIdMatch: false,
      isLoading: false,
    }
  }
  return ctx
}
